module.exports = __webpack_public_path__ + "static/media/education_new.fda680d1.svg";